import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './style.css';

import axios from "axios";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const AddPurchase = () => {

    const [purId, setPurId] = useState("");

    useEffect(() => {
        // Fetch the last clid and increment it
        axios.get("https://react-apis.dotlocalhost.com/purchaseid.php")
            .then(response => {
                setPurId(response.data.purchage_Id); // Set the incremented purId
            })
            .catch(error => {
                console.error("There was an error fetching the purId!", error);
            });
    }, []);




    let history = useNavigate();

    const [data, setData] = useState({
        clientName: "",
        productid: "",
        address: "",
        netWeight: ""
    })
    

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });

        //console.log(data)
    }


    //select from product database

    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [userPacking, setUserPacking] = useState(null);
    const [userNetWeight, setUserNetWeight] = useState(null);
    const [userQuantity, setUserQuantity] = useState(null);

    const [totalWeight, setTotalWeight] = useState(null);
    const [userShortage, setUserShortage] = useState(0);

    const [dataMaan, setDataMaan] = useState(null);
    const [dataPrice, setDataPrice] = useState(null);
    const [dataTotalPrice, setDataTotalPrice] = useState(null);

    const [clients, setClients] = useState([]);
    const [clientName, setClientName] = useState([]);
    const [productName, setProductName] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');



    // Fetch user first names when the component mounts
    useEffect(() => {
        fetch('https://react-apis.dotlocalhost.com/purchase.php')
            .then(response => response.json())
            .then(data => setUsers(data))
            .catch(error => console.error('Error fetching users:', error));

        fetch('https://react-apis.dotlocalhost.com/clientCl.php')
            .then(response => response.json())
            .then(data => setClients(data))
            .catch(error => console.error('Error fetching users:', error));

/*            
        fetch('https://react-apis.dotlocalhost.com/purchase.php')
            .then(response => response.json())
            .then(data => setProductName(data))
            .catch(error => console.error('Error fetching client names:', error));
            */

        // sidebar background color set
        // Change background color of the specific sidebar item
        const sidebarItemmatab = document.getElementById("spiceActiveTab");
        if (sidebarItemmatab) {
            sidebarItemmatab.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmatab.style.color = "#000000";
        }
        const sidebarItemmain = document.getElementById("prchg");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("prchgnw");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }        


        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmatab) {
                sidebarItemmatab.style.backgroundColor = "#F0F0F0"; // Reset to default when component unmounts
                sidebarItemmatab.style.color = "#000000"
            }
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }            
        };
            
    }, []);

    // Fetch the Client name of the selected user
    const handleClientChange = (event) => {
        const ClName = event.target.value;
        setSelectedClient(ClName);
        if (ClName) {
            fetch(`https://react-apis.dotlocalhost.com/clientCl.php?clid=${ClName}`)
                .then(response => response.json())
                .then(data => setClientName(data.clientName))
                //.then(data => setUserNetWeight(data.netWeight))
                .catch(error => console.error('Error fetching packing:', error));
        } else {
            setClientName(null);
        }
    };

    // Fetch the last name of the selected user
    const handleUserChange = (event) => {
        const ProName = event.target.value;
        setSelectedUser(ProName);
        if (ProName) {
            fetch(`https://react-apis.dotlocalhost.com/purchase.php?productid=${ProName}`)
                .then(response => response.json())
                .then(data => setProductName(data.productName) | setUserPacking(data.packing) | setUserNetWeight(data.netWeight) | setUserQuantity(userQuantity) | setTotalWeight(totalWeight) | setUserShortage(userShortage))
                //.then(data => setUserNetWeight(data.netWeight))
                .catch(error => console.error('Error fetching packing:', error));
        } else {
            setUserPacking(null);
            setUserNetWeight(null);
            setUserQuantity(null);
            setTotalWeight(null);
            setUserShortage(null);

        }
    };

    /*
    const handleClientChange = (event) => {
        setSelectedClient(event.target.value);
    };
    */


    useEffect(() => {
        const calculateTotalWeight = () => {
        const total = (userNetWeight * userQuantity) - userShortage;
        setTotalWeight(total);
        const total2 = dataMaan / 40 ;
        setDataPrice(total2);

        const total3 = totalWeight * dataPrice;
        setDataTotalPrice(total3);

        };
        calculateTotalWeight();
    }, [userNetWeight, userQuantity, userShortage, totalWeight, dataMaan, dataPrice]);



    //select from product database

    const [selectedDate, setSelectedDate] = useState(null);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const submitForm = (e) => {
        e.preventDefault();
        const sendData = {
            date: data.date,
            clid: selectedClient,
            clientName: clientName,
            shipping_mark: data.shipping_mark,
            purchage_Id: purId,
            productid: selectedUser,
            packing: userPacking,
            netWeight: userNetWeight,
            quantity: userQuantity,
            shortage: userShortage,
            totalWeight: totalWeight,
            price: dataPrice,
            totalBill: dataTotalPrice,
            duedate: selectedDate
        }

        console.log(sendData);

        axios.post('https://react-apis.dotlocalhost.com/addPurchase.php', sendData).then((result) => {
            if (result.data.Status == 'Invalid') {
                alert('Invalid purchase');
            } else {
                history('/purchased');
            }
        })

    }

    return (

        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Purchase New Item</h3>
                        </div>
                    </div>

                    <form onSubmit={submitForm}>

                        <div className='row'>
                            <div className='col-3'>
                                <label for="" class="form-label">Date</label>
                                <input type="date" name="date" className='form-control' onChange={handleChange} value={data.date}/>
                            </div>
                            <div className='col-2'>
                                <label htmlFor="clientDropdown">Client ID</label>
                                <select id="clientDropdown" name="clid" value={selectedClient} className='form-control' onChange={handleClientChange}>
                                    <option value="">--Select Client--</option>
                                    {clients.map((data) => (
                                        <option key={data.clid} value={data.clid}>{data.clid}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-3'>
                                <label for="" class="form-label">Client Name</label>
                                <input type="text" name="packing" className='form-control' onChange={handleChange} value={clientName} />
                            </div>
                            <div className='col-2'>
                                <label for="" class="form-label">Shipping Mark</label>
                                <input type="text" name="shipping_mark" className='form-control' onChange={handleChange} value={data.shipping_mark}/>
                            </div> 

                            <input style={{display:'none'}} type="text" id="purId" name='purId' value={purId} /> 

                        </div>
                        <div className='row'>       
{/*                             
                            <div className='col-3'>
                                <label for="" class="form-label">Product Name</label>
                                <select value={selectedUser} className='form-control' name="productName" onChange={handleUserChange}>
                                    <option value="">Select Products</option>
                                    {users.map(data => (
                                        <option key={data.productName} value={data.productName}>{data.productName}</option>
                                    ))}
                                </select>
                            </div>
*/}                            
                            <div className='col-2'>
                                <label htmlFor="clientDropdown">Product ID</label>
                                <select id="clientDropdown" name="clid" value={selectedUser} className='form-control' onChange={handleUserChange}>
                                    <option value="">--Select Product--</option>
                                    {users.map((data) => (
                                        <option key={data.productid} value={data.productid}>{data.productid}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-3'>
                                <label for="" class="form-label">Product Name</label>
                                <input type="text" name="packing" className='form-control' onChange={handleChange} value={productName} />
                            </div>


                            <div className='col-2'>
                                <label for="" class="form-label">Packing</label>
                                <input type="text" name="packing" className='form-control' onChange={handleChange} value={userPacking} />
                            </div>                     
                            <div className='col-2'>
                                <label for="" class="form-label">Net Weight</label>
                                <input type="text" name="netWeight" className='form-control' onChange={(e) => setUserNetWeight(Number(e.target.value))} value={userNetWeight} />
                            </div>
                            <div className='col-2'>
                                <label for="" class="form-label">Quantity</label>
                                <input type="text" name="quantity" className='form-control' onChange={(e) => setUserQuantity(Number(e.target.value))} value={userQuantity} />
                            </div>
                            <div className='col-2'>
                                <label for="" class="form-label">Shortage</label>
                                <input type="text" name="shortage" className='form-control' onChange={(e) => setUserShortage(Number(e.target.value))} value={userShortage} />
                            </div>                                                        
                        </div>
                        <div className='row'>    
                            <div className='col-2'>
                                <label for="" class="form-label">Total Weight</label>
                                <input type="text" name="totalWeight" className='form-control' value={totalWeight} />
                            </div>                        
                            <div className='col-2'>
                                <label for="" class="form-label">Price/Maan</label>
                                <input type="text" name="price" className='form-control' onChange={(e) => setDataMaan(Number(e.target.value))} value={dataMaan} />
                            </div>
                            <div className='col-2'>
                                <label for="" class="form-label">Price/KG</label>
                                <input type="text" name="price" className='form-control' onChange={(e) => setDataPrice(Number(e.target.value))} value={dataPrice} />
                            </div>
                            <div className='col-2'>
                                <label for="" class="form-label">Total Bill</label>
                                <input type="text" name="totalPrice" className='form-control' value={dataTotalPrice} />
                            </div>
                            <div className='col-2'>
                                <label for="" class="form-label">Due Date</label>
                                <DatePicker selected={selectedDate} onChange={handleDateChange} className='form-control' dateFormat="yyyy-MMM-dd" />
                            </div>                            
                        </div>

                        <div className="row">
                            <div className='col-6 mt-5'>
                                <div className="d-grid gap-3">
                                    <input type="submit" name="submit" value="Add New Purchase" className="btn btn-primary btn-block" />
                                </div>
                            </div>
                        </div>

                    </form>

                </div>

            </div>
        </div>
    )
}

export default AddPurchase;